export default "\n<span >\n  <pre>{{users | json}}</pre>\n</span>\n"